import NewProgressBar from "./NewProgressBar";

export default NewProgressBar;
